import { api } from "api/api";
import { AxiosError } from "axios";
import FormaPagamento from "model/fiscal/FormaPagamento";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class FormaPagamentoService implements BaseServiceCadastros<FormaPagamento> {

    getAll() {
        return new Promise<FormaPagamento[]>((resolve, reject): void => {
            api
                .get(`/formaPagamento/getAll`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/formaPagamento/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<FormaPagamento>((resolve, reject): void => {
            api
                .get(`/formaPagamento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(formaPagamento: FormaPagamento) {
        return new Promise<FormaPagamento>((resolve, reject): void => {
            api
                .post(`/formaPagamento/incluir`, JSON.stringify(formaPagamento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(formaPagamento: FormaPagamento) {
        return new Promise<FormaPagamento>((resolve, reject): void => {
            api
                .put(`/formaPagamento/editar`, JSON.stringify(formaPagamento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/formaPagamento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposPagamentoNfe() {
        return [
            { label: "Dinheiro", value: "01" },
            { label: "Cheque", value: "02" },
            { label: "Cartão de Crédito", value: "03" },
            { label: "Cartão de Débito", value: "04" },
            { label: "Crédito Loja", value: "05" },
            { label: "Vale Alimentação", value: "10" },
            { label: "Vale Refeição", value: "11" },
            { label: "Vale Presente", value: "12" },
            { label: "Vale Combustível", value: "13" },
            { label: "Duplicata Mercantil", value: "14" },
            { label: "Boleto Bancário", value: "15" },
            { label: "Depósito Bancário", value: "16" },
            { label: "Pagamento Instantâneo (PIX) Dinâmico", value: "17" },
            { label: "Transferência entre Contas", value: "18" },
            { label: "Programa de Fidelidade", value: "19" },
            { label: "Pagamento Instantâneo (PIX) Estático", value: "20" },
            { label: "Crédito Loja", value: "21" },
            { label: "Pagamento Eletrônico não informado", value: "22" },
            { label: "Sem pagamento", value: "90" },
            { label: "Outros", value: "99" }
        ]
    }

}
export default FormaPagamentoService;
